import HttpService from "./HttpService";

const resource = "/notificacao-web"

let service = {
  getPaginado: (filtro, pagina, sort) => {
    return HttpService.backApi.get(`${resource}/paginado?page=${pagina.page - 1}&size=${pagina.itemsPerPage}&status=${filtro.status}&sort=${sort}`);
  },
  getAllPaginado: (filtro, pagina, sort) => {
    return HttpService.backApi.get(`${resource}/all/paginado?page=${pagina.page - 1}&size=${pagina.itemsPerPage}&status=${filtro.status}&sort=${sort}`);
  },
  getQuantidadeNotificacoesNaoLidas: () => {
    return HttpService.backApi.get(`${resource}/quantidade`);
  },
  atualizarStatusNotificacaoWeb: (body) => {
    return HttpService.backApi.put(`${resource}/atualizar-status`, body);
  },
  remover: (notificacao) => {
    return HttpService.backApi.delete(`${resource}/${notificacao.cdNotificacaoWeb}`);
  },
  notificar: (notificacao) => {
    return HttpService.backApi.post(`${resource}`, {...notificacao, cd_usuario: notificacao.cdUsuario, cd_owner: notificacao.cdOwner});
  },
};

export default service;